module.exports = __webpack_public_path__ + "img/person.41813508.png";